class StoreLocatorForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('#search-location-form');
        this.input = this.querySelector('.search-location__input-box');
        this.button = this.querySelector('.search-location-button');
        this.storeButtons = this.querySelectorAll('.each-store-button');
        this.selectedStore = null;
        this.latitude = null;
        this.longitude = null;
        this.dataAvailable = false;

        // Bind the context for event handler
        this.handleSubmit = this.handleSubmit.bind(this);
        this.requestLocationAccess = this.requestLocationAccess.bind(this);
        this.hideAddressContainer = this.hideAddressContainer.bind(this);
        this.makeApiCall = this.makeApiCall.bind(this);
        this.selectStore = this.selectStore.bind(this);
    }

    connectedCallback() {
        if (this.storeButtons.length > 0) {
            this.selectStore(this.storeButtons[0]); // Select the first button by default
        }

        // Ensure the DOM is fully loaded before trying to access the element
        document.addEventListener('DOMContentLoaded', () => {
            this.hideAddressContainer(); // Call to hide the container
        });

        // Add event listeners
        if (this.form) {
            this.form.addEventListener('submit', this.handleSubmit);
        }

        if (this.storeButtons) {
            this.storeButtons.forEach(button => {
                button.addEventListener('click', (event) => {
                    this.selectStore(button); // Select the clicked button
                });
            });
        }

        // Request location access on page load
        if (!sessionStorage.getItem('latitude') || !sessionStorage.getItem('longitude')) {
            this.requestLocationAccess();
        }
    }

    disconnectedCallback() {
        // Clean up event listeners
        if (this.form) {
            this.form.removeEventListener('submit', this.handleSubmit);
        }

        if (this.storeButtons) {
            this.storeButtons.forEach(button => {
                button.removeEventListener('click', this.selectStore);
            });
        }
    }

    // This function will invoke when we select the store type
    selectStore(button) {
        // Remove 'active-button' class from all buttons
        this.storeButtons.forEach(eachButton => {
            eachButton.classList.remove('active-button');
        });

        // Add 'active-button' class to the clicked button
        button.classList.add('active-button');
        
        // Capture the selected store type from button text
        this.selectedStore = button.textContent.trim();

        // Trigger API call with the new store type
        this.makeApiCall();
    }

    // This function will invoke when we make API call
    makeApiCall() {
        // Display loader before starting the API call
        this.displayLoader(true);

        const location = this.input.value.trim(); // Get input value
        const latitude = sessionStorage.getItem('latitude') || this.latitude;
        const longitude = sessionStorage.getItem('longitude') || this.longitude;
    
        let isPincode = /^\d+$/.test(location); // Check if input is pincode
        let storeLocatorUrl;
        let storeType = null;

        if (this.selectedStore.includes('Raymond Shop')){
            storeType = 'top_raymonds_stores';
        }
        else if (this.selectedStore.includes('Ready To Wear Store')){
            storeType = 'top_ready_to_wear_stores';
        }
        else if (this.selectedStore.includes('Made To Measure Store')){
            storeType = 'top_made_to_measure_shops';
        }
    
        // Base API URL
        let baseUrl = `https://www.promanage.biz/api/profile/store_locator?auth_key=5d0c09d1-8459-42ea-951e-b193dc27d517&PageNo=1&pageSize=15&Store_type=${storeType}&radius=10`;
    
        // Conditionally add latitude and longitude if they exist
        if (latitude && longitude) {
            baseUrl += `&lat=${latitude}&long=${longitude}`;
        }
    
        // Determine whether to pass pincode or city name
        if (isPincode) {
            storeLocatorUrl = `${baseUrl}&Pincode=${location}`;
        } else if (location) {
            storeLocatorUrl = `${baseUrl}&cityname=${location}`;
        } else {
            storeLocatorUrl = baseUrl; // No location input
        }

        let responseDataCount;
    
        fetch(storeLocatorUrl)
            .then(response => {
                // Check if the response status is OK (200-299 range)
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse the response JSON
            })
            .then(data => {
                // Handle the API response data
                if (data && data.response_Data && data.response_Data.length > 0) {
                    // Assuming the API returns a 'stores' array in the response
                    this.displayStores(data.response_Data);
                    responseDataCount = data.response_Data.length;
                    this.displayCardsCount(responseDataCount); // Call a function to display stores
                    this.displayCategoryTypeText(this.selectedStore);
                    this.dataAvailable = true;
                    if (location) {
                        this.displayInputText(location);
                    }
                } else {
                    this.dataAvailable = false;
                    throw new Error('No stores data found in response');
                }
            })
            .catch(error => {
                console.error('Error fetching API:', error.message);
                this.dataAvailable = false;
                this.displayErrorMessage(this.dataAvailable);
                
            })
            .finally(() => {
                this.displayLoader(false);
                this.hideAddressContainer(this.dataAvailable);
            });
    }
    
    // This function will invoke and creates the address cards & displays it, when we get the response from the API
    displayStores(stores) {
        const parentContainer = document.querySelector('.response-address-cards-container');
        
        // Clear existing store cards before adding new ones
        parentContainer.innerHTML = '';
        
      
        stores.forEach(store => {
        
        // Skip store if no image is available
        if (!store.store_image) return;

        let storeCard = `
          <div class="store-locator-address-card-container">
            <div class="store-locator-address-card-image-container">
              <img src="${store.store_image}" alt="${store.store_name}" />
            </div>
            <div class="store-locator-address-card-content">
              <h4 class="store-locator-address-card-title outfit-semibold">${store.store_name}</h4>
              <div class="store-locator-address-card-location-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none" class="icon location-icon">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.14486 13.6667C6.14486 13.6667 11.4782 9.66671 11.4782 5.66671C11.4782 4.25222 10.9163 2.89567 9.91609 1.89547C8.9159 0.895277 7.55934 0.333374 6.14486 0.333374C4.73037 0.333374 3.37381 0.895277 2.37362 1.89547C1.37343 2.89567 0.811523 4.25222 0.811523 5.66671C0.811523 9.66671 6.14486 13.6667 6.14486 13.6667ZM6.14486 8.33335C7.61762 8.33335 8.81152 7.13944 8.81152 5.66668C8.81152 4.19392 7.61762 3.00001 6.14486 3.00001C4.6721 3.00001 3.47819 4.19392 3.47819 5.66668C3.47819 7.13944 4.6721 8.33335 6.14486 8.33335Z" fill="black"/>
                </svg>
                <span class="store-locator-address-card-location-address outfit-medium">${store.store_address}</span>
              </div>
              <div class="store-locator-address-card-mobile-number-wrapper" style="visibility: ${store.mobile_number ? 'visible' : 'hidden'};">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" class="icon mobile-icon">
                  <path d="M12.1442 9.48431V11.2908C12.1448 11.4585 12.1104 11.6245 12.0431 11.7781C11.9758 11.9318 11.8771 12.0697 11.7532 12.1831C11.6294 12.2965 11.4832 12.3828 11.324 12.4365C11.1649 12.4903 10.9962 12.5102 10.8288 12.4951C8.97221 12.2938 7.18879 11.6606 5.62187 10.6465C4.16406 9.72196 2.92809 8.48843 2.00173 7.03351C0.982048 5.46259 0.347476 3.67405 0.149429 1.81277C0.134351 1.64625 0.15418 1.47843 0.207653 1.31998C0.261125 1.16153 0.347071 1.01592 0.460016 0.892439C0.572961 0.768955 0.710432 0.670295 0.863677 0.60274C1.01692 0.535185 1.18258 0.500216 1.35011 0.500058H3.16018C3.45299 0.497182 3.73686 0.600667 3.95888 0.791223C4.1809 0.981779 4.32591 1.24641 4.36689 1.53578C4.44329 2.11389 4.58497 2.68152 4.78924 3.22785C4.87042 3.44338 4.88799 3.67761 4.83987 3.9028C4.79175 4.12799 4.67995 4.33469 4.51773 4.49841L3.75147 5.26315C4.61038 6.77069 5.86108 8.01891 7.37161 8.87612L8.13787 8.11138C8.30192 7.94948 8.50903 7.83791 8.73466 7.78988C8.9603 7.74185 9.195 7.75939 9.41095 7.8404C9.95836 8.04427 10.5271 8.18567 11.1064 8.26192C11.3995 8.30318 11.6671 8.45052 11.8585 8.6759C12.0498 8.90128 12.1515 9.18899 12.1442 9.48431Z" fill="black"/>
                </svg>
                <span class="store-locator-address-card-mobile-number outfit-medium">${store.mobile_number}</span>
              </div>
              <a href="${store.direction_button_url}" target="_blank" class="store-locator-address-card-direction-button outfit-medium">GET DIRECTIONS</a>
            </div>
          </div>
        `;

          // Append the store card to the parent container
          parentContainer.innerHTML += storeCard;
        });
    }

    // This function will invoke and displays the loader before getting the response from the API
    displayLoader(show) {
        this.hideAddressContainer();
        const errorMessage = document.querySelector('.error-messaging-text');
        const loader = document.querySelector('.store-locator-loader');

        if (show) {
            loader.classList.remove('hide-element');
        } else {
            loader.classList.add('hide-element');
        }

        if (this.dataAvailable){
            errorMessage.classList.add('hide-element');
        }
        else{
            errorMessage.classList.remove('hide-element');
        }
    }

    // This function will invoke when loading the page for the first time to get location details of the customer
    requestLocationAccess() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.latitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                    sessionStorage.setItem('latitude', this.latitude);
                    sessionStorage.setItem('longitude', this.longitude);

                    // Trigger API call after obtaining location
                    this.makeApiCall();
                },
                (error) => {
                    console.warn('Location access denied or unavailable:', error.message);
                    // Proceed without location
                    this.makeApiCall();
                }
            );
        } else {
            console.warn('Geolocation is not supported by this browser.');
            this.makeApiCall(); // Call API without location
        }
    }

    // This function will invoke and display the response array of objects count or cards count
    displayCardsCount(count){
        const addressCardsContainer = document.querySelector('.address-cards-main-container .cards-count-text');
        addressCardsContainer.textContent = `Showing ${count}`;
    }

    // This function will invoke and display the given input text
    displayInputText(inputText){
        const displayInputTextElement = document.querySelector('.address-cards-main-container .entered-input-text');
        displayInputTextElement.textContent = ` in ${inputText}`;
    }

    // This function will invoke and display when response array of objects count is  zero
    displayErrorMessage(isDataAvailable){
        const errorMessageText = document.querySelector('.error-messaging-text');
        errorMessageText.textContent = 'No Data Found';

        if (isDataAvailable) {
            errorMessageText.classList.add('hide-element');
        } else {
            errorMessageText.classList.remove('hide-element');
        }
    }

    // This function will invoke and hide the main container basing on the response data.
    hideAddressContainer(isDataAvailable) {
        const addressCardsContainer = document.querySelector('.address-cards-main-container');
        
        if (addressCardsContainer) {
            if (isDataAvailable) {
                addressCardsContainer.classList.remove('hide-element');  // Show container if data is available
            } else {
                addressCardsContainer.classList.add('hide-element');   // Hide container if no data
            }
        }
    }

    // This function will invoke and display the selected category type text
    displayCategoryTypeText(categoryText){
        const categoryTextElement = document.querySelector('.category-type-text');
        categoryTextElement.textContent = categoryText;
    }

    // This function  will invoke when we clicked on submit button
    handleSubmit(event) {
        if (this.input.textContent === "") {
            const displayInputTextElement = document.querySelector('.address-cards-main-container .entered-input-text');
            displayInputTextElement.textContent = '';
        }

        if (event) {
            event.preventDefault();
        }


        // Trigger API call on form submit
        this.makeApiCall();
    }
}

// Define the custom element
customElements.define('store-locator-form', StoreLocatorForm);
